import React, { useEffect, useState } from 'react';
import { FormControl, FormLabel, Select, HStack, Button, Box } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllAcademicYear } from '../../../features/academicYearSlice';
import { getGradosBySede } from '../../../features/gradoSlice';
import { useLocation } from 'react-router-dom';
import ConsolidadoGeneralReporteButton from './ConsolidadoGeneralReporte';

const ConsolidadoGeneral = () => {

    const dispatch = useDispatch();
    const location = useLocation();
    const sedeId = location.state?.sedeId;

    const { academic_year } = useSelector(state => state.academic_year);
    const { grados } = useSelector(state => state.grados);

    const initialData = {
        year: '',
        grado: '',
        sede: sedeId
    }
    const [data, setData] = useState(initialData);

    useEffect(() => {
        dispatch(getAllAcademicYear());
        dispatch(getGradosBySede(sedeId));
    }, []);

    return (
        <Box p={4} align="center">
            <HStack spacing={2} justifyContent="stretch">
                <FormControl>
                    <FormLabel>AÑO LECTIVO</FormLabel>
                    <Select
                        placeholder="Seleccione el año lectivo"
                        onChange={e => setData({ ...data, year: e.target.value })}
                    >
                        {
                            academic_year.map(item => (
                                <option key={item._id} value={item._id}>{item.year}</option>
                            ))
                        }
                    </Select>
                </FormControl>

                <FormControl>
                    <FormLabel>SELECCIONE EL GRADO</FormLabel>
                    <Select
                        placeholder="Seleccione el grado"
                        onChange={e => setData({ ...data, grado: e.target.value })}
                        isDisabled={!data.year}
                    >
                        {
                            grados.map(grado => (
                                <option key={grado?._id} value={grado?._id}>{grado?.nombre + ' - ' + grado?.nivel}</option>
                            ))
                        }
                    </Select>
                </FormControl>
            </HStack>
            {
                data.grado && data.year && (
                    <ConsolidadoGeneralReporteButton
                        datos={data}
                        dato_grado={grados.find(grado => grado._id === data.grado)}
                        dato_periodo={academic_year.find(ay => ay._id === data.year)}
                    />
                )
            }
        </Box>
    );
};

export default ConsolidadoGeneral;